module.exports = __webpack_public_path__ + "img/201-8b034d.png";